import { render, staticRenderFns } from "./UserPostSingle.vue?vue&type=template&id=382cb623&"
import script from "./UserPostSingle.vue?vue&type=script&lang=js&"
export * from "./UserPostSingle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports